export default [

    {
        path: '/dashboard',
        name: 'Главная',
        view: 'Dashboard'
    },
    {
        path: '/dealers',
        name: 'Рейтинг дилеров',
        view: 'Dealers'
    },
    {
        path: '/activations',
        name: 'Активация товаров',
        view: 'Activations'
    },
    {
        path: '/serials',
        name: 'Серийники',
        view: 'Serials'
    },
    {
        path: '/outlets',
        name: 'Торговые точки',
        view: 'Outlets'
    },

    {
        path: '/orders',
        name: 'Заказы дилеров',
        view: 'Orders'
    },
    {
        path: '/products',
        name: 'Продукция',
        view: 'Products'
    },
    {
        path: '/news',
        name: 'Объявления дилерам',
        view: 'News',
    },
    {
        path: '/feedback',
        name: 'Онлайн-чат',
        view: 'Feedback'
    },
    {
        path: '/raffles',
        name: 'Розыгрыши',
        view: 'Raffles'
    },
    {
        path: '/pages',
        name: 'Страницы и новости',
        view: 'Pages'
    },
    {
        path: '/roles',
        name: 'Роли пользователей',
        view: 'Moderators'
    },
    {
        path: '/sliders',
        name: 'Слайдеры',
        view: 'Sliders'
    },
    {
        path: '/history-1c',
        name: '1с загрузки',
        view: 'History'
    },
    {
        path: '/distributions',
        name: 'Дистрибьюторы',
        view: 'Distributions'
    },
    {
        path: '/users',
        name: 'Пользователи',
        view: 'Users'
    },
    {
        path: '/courses',
        name: 'Курс доллара',
        view: 'Courses'
    },
    {
        path: '/buyers',
        name: 'Активации покупателей',
        view: 'Buyers'
    },
    {
        path: '/group-dealer',
        name: 'Группы дилеров',
        view: 'GroupDealer'
    },
    {
        path: '/tournaments',
        name: 'Турниры',
        view: 'Tournaments'
    },
    {
        path: '/clients',
        name: 'Покупатели',
        view: 'Clients'
    },
    {
        path: '/distributions/orders',
        name: 'Заказы дистрибьюторов',
        view: 'DistributionsOrders'
    },
    {
        path: '/distributions/group',
        name: 'Заказы дистрибьюторов',
        view: 'DistributionsGroup'
    },
]